module.exports = __webpack_public_path__ + "img/post.393c24bf.png";